module.exports = __webpack_public_path__ + "img/PENDING_ORANGE.8b800217.svg";